import { Route, Routes } from "react-router-dom";

import React from "react";
import Footer from "../../components/Layout/Footer";
import Header from "../../components/Layout/Header";
import HomeContent from "../Home/HomeContent";
import Layout from "../../components/Layout/Layout";
import MattressBuilder from "./MattressBuilder";
import styled from "styled-components";

const StyledBodyContainer = styled.div``;

const MattressBuilderApp = () => {
  return (
    <Layout>
      {/*  Header */}
      <Header showBuildMyBed={false} showCart={true} cartIconColor={"white"} />
      {/*  Body */}
      <StyledBodyContainer
        className={"builder-container"}
        style={{
          margin: "0 auto",
          maxWidth: 1920,
          height: "90vh",
          overflow: "auto",
          overscrollBehavior: "contain",
          padding: "1rem 1.0875rem 1.45rem",
          zIndex: 300,
        }}
      >
        <main>
          <Routes>
            <Route path="/" element={<MattressBuilder />}></Route>
            <Route
              path="*"
              element={
                <main style={{ padding: "1rem" }}>
                  <p>There is nothing here evrbed, homepage!</p>
                </main>
              }
            />
          </Routes>
        </main>
      </StyledBodyContainer>
      {/*  Footer */}
      <Footer showMenuButton={true} styles={{ zIndex: 1100 }}></Footer>
    </Layout>
  );
};

export default MattressBuilderApp;
